

const _shared = "font-bold bg-gradient-to-br bg-clip-text text-transparent"
export const SPECIAL_TEXT_GRADIENT = `from-rose-500 via-purple-500 to-blue-500 ${_shared}`;
export const SPECIAL_TEXT_ALT = `from-cyan-400 via-blue-500 to-purple-600 ${_shared}`